import { postInternalMessage } from '../initialize';
import { createRemoveCallableAssociationMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { triggerHostMessageRemoveCallableAssociation } from '../triggerHostMessage/triggerHostMessageRemoveCallableAssociation';
export default function removeCallableAssociation(callableAssociation) {
  const message = createRemoveCallableAssociationMessage(callableAssociation);
  postInternalMessage(message);
  triggerHostMessageRemoveCallableAssociation(callableAssociation);
}